export default "__VITE_PUBLIC_ASSET__8762f7ae__"